import {makeAutoObservable} from "mobx"
import {api, catchApi} from "../../api";
import {SortTypeDto, VehicleDataAcquisitionSortByDto, VehicleDataAcquisitionStatusDto,} from "../../api/vda";

interface OverviewItem {
    id: string
    customer: string
    fin: string
    date: string
    status: VehicleDataAcquisitionStatusDto
}

class VdaOverviewStore {
    get customerId(): string | undefined {
        return this._customerId;
    }

    set customerId(value: string | undefined) {
        this._customerId = value;
    }

    get status(): VehicleDataAcquisitionStatusDto[] | undefined {
        return this._status;
    }

    set status(value: VehicleDataAcquisitionStatusDto[] | undefined) {
        this._status = value;
    }

    get toAbsolute(): string | undefined {
        return this._toAbsolute;
    }

    set toAbsolute(value: string | undefined) {
        this._toAbsolute = value;
    }

    get fromAbsolute(): string | undefined {
        return this._fromAbsolute;
    }

    set fromAbsolute(value: string | undefined) {
        this._fromAbsolute = value;
    }

    set toRelative(value: string | undefined) {
        this._toRelative = value;
    }

    get toRelative(): string | undefined {
        return this._toRelative;
    }

    get fromRelative(): string | undefined {
        return this._fromRelative;
    }

    set fromRelative(value: string | undefined) {
        this._fromRelative = value;
    }

    get query(): string | undefined {
        return this._query;
    }

    set query(value: string | undefined) {
        this._query = value;
    }

    get sortType(): SortTypeDto | undefined {
        return this._sortType;
    }

    set sortType(value: SortTypeDto | undefined) {
        this._sortType = value;
    }

    get sortBy(): VehicleDataAcquisitionSortByDto | undefined {
        return this._sortBy;
    }

    set sortBy(value: VehicleDataAcquisitionSortByDto | undefined) {
        this._sortBy = value;
    }

    get items(): OverviewItem[] {
        return this._items;
    }

    private set items(value: OverviewItem[]) {
        this._items = value;
    }

    get size(): number {
        return this._size;
    }

    set size(value: number) {
        this._size = value;
    }

    get page(): number {
        return this._page;
    }

    set page(value: number) {
        this._page = value;
    }

    get pages(): number {
        return this._pages;
    }

    set pages(value: number) {
        this._pages = value;
    }

    private _items: OverviewItem[] = []

    private _pages: number = 0
    private _page: number = 0
    private _size: number = 25
    private _sortBy: VehicleDataAcquisitionSortByDto | undefined
    private _sortType: SortTypeDto | undefined
    private _query: string | undefined
    private _fromRelative: string | undefined
    private _toRelative: string | undefined
    private _fromAbsolute: string | undefined
    private _toAbsolute: string | undefined
    private _customerId: string | undefined
    private _status: VehicleDataAcquisitionStatusDto[] | undefined

    constructor() {
        makeAutoObservable(this)
    }

    async load() {

        const {
            page,
            size,
            sortBy,
            sortType,
            query,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
            status
        } = this

        const response = await catchApi(async () => api.vda.api.listVehicleDataAcquisition({
            page: page - 1,
            size,
            sortBy,
            sortType,
            q: query,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
            status

        }))

        const responseData = response?.data
        this.pages = responseData?.totalPages || 0
        this.items = (responseData?.items || []).map(e => ({
            id: `${e.id}`,
            fin: `${e.vin}`,
            customer: `${e.customer}`,
            date: `${e.createdDate}`,
            status: e.status || VehicleDataAcquisitionStatusDto.ACQUISITION
        }))
    }
}

const vdaOverviewStore = new VdaOverviewStore()

export {
    vdaOverviewStore
}
